import Action from './Action'
import router from '../../router'

export default class ShowViewAction extends Action {
  handle () {
    router.push({ name: this.data.view, params: this.data.props })
  }
}
